import React from 'react';
import PropTypes from 'prop-types';

// Bloque gris que ocupa el lugar de un dato mientras llega; ver `.esqueleto` en Global.css.
const Esqueleto = ({ ancho = '100%', alto = 14, radio = 6, className = '' }) => (
  <span
    className={`esqueleto ${className}`}
    style={{ width: ancho, height: alto, borderRadius: radio }}
    aria-hidden="true"
  />
);

Esqueleto.propTypes = {
  ancho: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  alto: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  radio: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string
};

export default Esqueleto;
